module.exports = __webpack_public_path__ + "img/fi-rr-arrow-small-right.03a91c66.svg";